import React from 'react';
import { CircleHelp } from 'lucide-react';
import { useHelp } from '../../contexts/HelpContext';

const HelpFloatingButton = () => {
  const { toggleHelp, isOpen } = useHelp();
  
  // Hide the peek button when drawer is open
  if (isOpen) return null;
  
  return (
    <button
      onClick={toggleHelp}
      style={{
        borderTopLeftRadius: '12px',
        borderTopRightRadius: '12px',
        borderBottomLeftRadius: '0',
        borderBottomRightRadius: '0',
      }}
      className="fixed bottom-0 right-8 z-50 px-4 py-2 bg-primary text-primary-foreground shadow-[0_-4px_12px_rgba(0,0,0,0.15)] hover:pb-3 translate-y-[45%] hover:translate-y-0 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 flex items-center gap-1.5 border-t border-l border-r border-primary-foreground/20"
      aria-label="Toggle Help"
    >
      <CircleHelp className="w-3 h-3" />
      <span className="text-xs font-medium">Help</span>
    </button>
  );
};

export default HelpFloatingButton;
